




































import { useChannelsStore } from "@/store/useChannelsStore";
import { supportsMessageStatusUpdates } from "@/utils/channels";
import { resolveMessageStatusClass, resolveMessageStatusIcon, resolveMessageStatusText } from "@/utils/chats";
import { formatDate } from "@/utils/luxon";
import { ChatEntry } from "@/views/modules/messaging-inbox/useChat";
import { computed, defineComponent, PropType } from "@vue/composition-api";
import { VBTooltip } from "bootstrap-vue";

export default defineComponent({
    directives: {
        "b-tooltip": VBTooltip,
    },
    props: {
        entry: { type: Object as PropType<ChatEntry>, required: true },
    },
    setup(props) {
        const channelsStore = useChannelsStore();

        const isAssetImage = computed(
            (): boolean =>
                props.entry.assets?.length &&
                props.entry.assets[0].category === "image" &&
                !props.entry.message &&
                (!props.entry.components || Object.keys(props.entry.components).length === 0) &&
                !("replyToMessageId" in props.entry.metadata)
        );

        return {
            channelsStore,
            formatDate,
            resolveMessageStatusClass,
            resolveMessageStatusIcon,
            supportsMessageStatusUpdates,
            resolveMessageStatusText,
            isAssetImage,
        };
    },
});
